import { useEffect, useState } from 'react';
import s from './dashboard.module.scss'
import { Outlet, useLocation } from 'react-router-dom'
import classNames from 'classnames'
import { useMedia } from 'use-media';
import { useProfile } from '@shared/api/useProfile';
import { FetchingDiv } from '@shared/ui/fetching-div/fetching-div';
import { LeftSidebar } from '@widgets/layout/ui/sidebar/sidebar';
import { DashboardHeader } from '@widgets/layout/ui/dashboard-header/dashboard-header';
import { DashboardBottombar } from '@widgets/layout/ui/dashboard-bottombar/dashboard-bottombar';

export const Dashboard = () => {
	const [showSidebar, set_showSidebar] = useState(false)

	const {pathname} = useLocation()

	const {data: profile, isFetched } = useProfile()

	const isTablet = useMedia({maxWidth: '1312px'})
	const isMobile = useMedia({maxWidth: '768px'})

	useEffect(() => {
		set_showSidebar(false)
	}, [pathname])


	return (
		<FetchingDiv className={s.wrapper} isFetching={!isFetched}>
			<div className={s.content}>
				{isMobile ? null : 
				<>
					<div className={s.hiddenSidebar}>
						<div className={classNames(s.bgSidebar, showSidebar ? s.active : null)} onClick={() => set_showSidebar(false)}></div>
						<LeftSidebar {...{profile}} isHidden={true} active={showSidebar} closeSidebar={() => set_showSidebar(false)} isDynamic={true}/>
					</div>
					<LeftSidebar {...{profile, isTablet}}/>
				</>}
				<div className={s.dashboardLeftCol}>
					{(isTablet && !isMobile) ? <DashboardHeader {...{set_showSidebar, profile, isMobile}}/> : null}
					<div className={s.contentWrapper}>
						<Outlet/>
					</div>
				</div>
			</div>
			{isMobile ? <DashboardBottombar/> : null}
		</FetchingDiv>
	)
}